import { AsyncPipe } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { SettingsService, SettingsStorage } from '@next/core-lib/settings';
import { Observable, Subject } from 'rxjs';
import { debounceTime, map, takeUntil, tap } from 'rxjs/operators';

import { InvoiceView } from './models/invoice.model';
import { SettingsKeys, settingsContextName } from '../shared/models/shared.models';
import { InvoiceDetailedOverviewComponent } from './components/invoice-detailed-overview/invoice-detailed-overview.component';
import { InvoiceOverviewComponent } from './components/invoice-overview/invoice-overview.component';
import { InvoiceTotalsComponent } from './components/invoice-totals/invoice-totals.component';

@Component({
  selector: 'app-invoice',
  templateUrl: './invoice.component.html',
  styleUrls: [],
  imports: [
    InvoiceOverviewComponent,
    InvoiceDetailedOverviewComponent,
    InvoiceTotalsComponent,
    AsyncPipe,
  ],
})
export class InvoiceComponent implements OnInit, OnDestroy {
  public invoiceViewDataNotAvailableYet = true;

  public readonly invoiceViewType = InvoiceView;

  public invoiceView$: Observable<InvoiceView>;
  private readonly destroy$ = new Subject<void>();

  constructor(private readonly settingsService: SettingsService) {}

  ngOnInit(): void {
    this.invoiceView$ = this.settingsService
      .getSettingsUpdates({
        contextName: settingsContextName,
        storage: SettingsStorage.PlatformSession,
        key: SettingsKeys.invoiceView,
      })
      .pipe(
        debounceTime(0),
        map((settings) =>
          settings?.map((setting) => (Array.isArray(setting) ? setting[0] : setting)),
        ),
        map((settings) => settings?.[0]?.data as InvoiceView),
        tap(() => {
          this.invoiceViewDataNotAvailableYet = false;
        }),
        takeUntil(this.destroy$),
      );
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
